import React from 'react';
import { array, func } from 'prop-types';

import { Slider } from '@atlas/components';

const propTypes = {
  bonuses: array.isRequired,
  renderBonus: func.isRequired,
};

const BonusesWrapper = ({ bonuses, renderBonus }) => {
  const shouldUseSlider = bonuses.length > 4;
  const renderedBonuses = bonuses.map(bonus =>
    shouldUseSlider ? (
      <Slider.Slide key={bonus.id}>{renderBonus(bonus)}</Slider.Slide>
    ) : (
      renderBonus(bonus)
    ),
  );

  return shouldUseSlider ? (
    <div className="slider-wrapper">
      <Slider
        className="bonus-list-slider"
        nextBtn={<Slider.NextBtn className="arrow next" />}
        prevBtn={<Slider.PrevBtn className="arrow prev" />}
        slidesPerView={4}
      >
        {renderedBonuses}
      </Slider>
    </div>
  ) : (
    <div className="registration-bonus-popup__bonus-list">{renderedBonuses}</div>
  );
};

BonusesWrapper.propTypes = propTypes;

export default BonusesWrapper;
